import ComponentManager from '@/Management/ComponentManager';
import UIListener from '@/UIListener/UIListener';
import DetailViewContext from '@/ViewModels/Contexts/DetailViewContext';
import ControlFactory from '@/Factories/ControlFactory';
import DatePickerViewModel from '@/ViewModels/Controls/DatePickerViewModel';

declare let moment: moment.MomentStatic;

export default class CurrencyExchangeUIListener extends UIListener {

    constructor() {
        super();
    }

    public onAfterRefresh(context: DetailViewContext): void {
        if (!(context instanceof DetailViewContext)) {
            return;
        }

        let datePickerViewModel = (context.getUIFactory('ValidFrom') as ControlFactory).viewModel as DatePickerViewModel;

        let date = moment(datePickerViewModel.date()).startOf('day');
        let today = moment().startOf('day');

        if (datePickerViewModel.value() != null && date.diff(today) < 0) {
            datePickerViewModel.isEnabled(false);
        } else {
            datePickerViewModel.min(today.toDate());
        }
    }
}

ComponentManager.setUIListener('CurrencyExchangeUIListener', CurrencyExchangeUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setUIListener('RADPresentation.DefaultViewExtensions.UIListener.CurrencyExchangeUIListener', CurrencyExchangeUIListener, 'RADPresentation.HTMLClient.DefaultViewExtensions');